import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Redirect } from 'react-router-dom';
import Functions from '../../api/Functions';
import { countryCodes, urls } from '../../constants/constants';
import M from 'materialize-css';

function PynsPeaceHill(props) {
  const [countryCode, setCountryCode] = useState(countryCodes.CA);
  const [radius, setRadius] = useState(500);
  const [idCompany, setIdCompany] = useState(null);
  const [urlPostalCodes, setUrlPostalCodes] = useState(urls.defaultGitsUrl);
  const [postalCodesSelected, setPostalCodeSelected] = useState([]);
  const [pynsCreated, setPynsCreated] = useState([]);
  const [postalCodes, setPostalCodes] = useState([]);
  const [showProcessing, setShowProcessing] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [update, setUpdate] = useState(0);

  useEffect(() => {
    M.AutoInit();
    M.updateTextFields();
  }, []);

  const { auth } = props;
  if (!auth.uid) return <Redirect to="/signin" />;

  const importPynsPeaceHill = () => {
    if (postalCodesSelected.length > 0 && idCompany) {
      setShowProcessing(true);
      setShowMessage(false);
      const promises = postalCodesSelected.map((postalCode) => {
        const { latitude, longitude } = postalCode;
        return Functions.importPynsPeaceHill(latitude, longitude, radius, idCompany, countryCode);
      });
      Promise.all(promises)
        .then((results) => {
          const pynsCreated = [];
          if (results && results.length > 0) {
            results.forEach((result, index) => {
              pynsCreated.push({
                code: postalCodesSelected[index].postalcode,
                cant: result.data.length,
              });
            });
          }
          setPynsCreated(pynsCreated);
          setShowProcessing(false);
        })
        .catch((e) => {
          setShowProcessing(false);
          console.log('Error runFunction:', e.message);
        });
    } else {
      setShowMessage(true);
    }
  };

  const getPostalCodes = () => {
    Functions.getPostalCodes(urlPostalCodes)
      .then((results) => {
        setPostalCodes(results.data);
      })
      .catch((e) => {
        console.log(e.message);
      });
  };

  const selectPostalCode = (value) => {
    if (postalCodesSelected.includes(value)) {
      const index = postalCodesSelected.indexOf(value);
      postalCodesSelected.splice(index, 1);
    } else {
      postalCodesSelected.push(value);
    }
    setPostalCodeSelected(postalCodesSelected);
    setUpdate(update + 1);
  };

  const selectAllPostalCodes = () => {
    const pc = [];
    postalCodes.forEach((postalCode) => {
      pc.push(postalCode);
    });
    setPostalCodeSelected(pc);
    setUpdate(update + 1);
  };

  const renderFormPostalCode = () => {
    return (
      <div className="input-field col s12">
        <input
          id="searchName"
          type="text"
          className="validate"
          value={urlPostalCodes}
          name="searchName"
          onChange={(e) => {
            setUrlPostalCodes(e.target.value);
          }}
        />
        <label htmlFor="searchName">Url postal Codes</label>
        <div className="row">
          <button className="waves-effect waves-light btn btn-large" onClick={() => getPostalCodes()}>
            Get Postal Codes
          </button>
          {postalCodes.length > 0 ? (
            <button className="waves-effect waves-light btn btn-large" onClick={selectAllPostalCodes}>
              Select All Postal Codes
            </button>
          ) : (
            <div />
          )}
          {postalCodes.length > 0 ? (
            <button className="waves-effect waves-light btn btn-large" onClick={() => setPostalCodeSelected([])}>
              Clean selected
            </button>
          ) : (
            <div />
          )}
        </div>
      </div>
    );
  };

  const renderPostalCodes = () => {
    return (
      <div className="input-field col s12 row">
        {postalCodes.map((value) => {
          const result = pynsCreated.filter((pynCreated) => pynCreated.code === value.postalcode);
          return (
            <div className={`col l1 m3 s12 card ${postalCodesSelected.includes(value) ? 'blue' : 'white'}`} onClick={() => selectPostalCode(value)} key={value.id}>
              <p className="">
                {value.postalcode} {result.length > 0 ? `Cant: ${result[0].cant}` : ''}
              </p>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div className="container">
      <div className="title-section">Pyns Peace Hill</div>
      <div className="row">
        <div className="input-field col s12">
          <input
            id="searchName"
            type="text"
            className="validate"
            value={idCompany}
            name="searchName"
            onChange={(e) => {
              setIdCompany(e.target.value);
            }}
          />
          <label htmlFor="searchName">Id Company</label>
        </div>
        <div className="input-field col s12">
          <input
            id="radius"
            type="number"
            className="validate"
            value={radius}
            name="radius"
            onChange={(e) => {
              setRadius(parseInt(e.target.value));
            }}
          />
          <label htmlFor="radius">Radius</label>
        </div>
        <div className="input-field col s12">
          <input
            id="countryCode"
            type="text"
            className="validate"
            value={countryCode}
            name="countryCode"
            onChange={(e) => {
              setCountryCode(e.target.value);
            }}
          />
          <label htmlFor="countryCode">Country Code</label>
        </div>
        {renderFormPostalCode()}
        {renderPostalCodes()}
        {showMessage ? <p>Select Postal Code</p> : <div />}
        {showProcessing ? <p>Processing</p> : <div />}
        <a href="#postalCode" className="waves-effect waves-light btn btn-large" onClick={importPynsPeaceHill}>
          Import Pyns Peace Hill
        </a>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    databases: state.firestore.ordered.databases,
    auth: state.firebase.auth,
  };
};

export default compose(connect(mapStateToProps))(PynsPeaceHill);
